export const ProductRouteNames = {
    collections: 'payments-collections',
    inventory: 'products-inventory',
    reviews: 'reviews-and-ratings',
    products: 'payments-products-v2',
    create: 'product-create-v2',
    details: 'product-details-v2',
    edit: 'product-edit-v2',
    stripe: 'import-stripe-product-v2',
    inventoryHistory: 'product-inventory',
    viewVariants: 'view-product-variants',
    bulkEdit: 'bulk-edit-products',
  }